var es = {
	"neptune.Button.loadingAriaLabel": "cargando",
	"neptune.Chips.ariaLabel": "Descartar {choice}",
	"neptune.ClearButton.ariaLabel": "Borrar",
	"neptune.CloseButton.ariaLabel": "Cerrar",
	"neptune.DateInput.day.label": "Día",
	"neptune.DateInput.day.placeholder": "DD",
	"neptune.DateInput.month.label": "Mes",
	"neptune.DateInput.year.label": "Año",
	"neptune.DateInput.year.placeholder": "AAAA",
	"neptune.DateLookup.day": "día",
	"neptune.DateLookup.goTo20YearView": "Ir a vista de 20 años",
	"neptune.DateLookup.month": "mes",
	"neptune.DateLookup.next": "siguiente",
	"neptune.DateLookup.previous": "anterior",
	"neptune.DateLookup.selected": "seleccionado",
	"neptune.DateLookup.twentyYears": "20 años",
	"neptune.DateLookup.year": "año",
	"neptune.FlowNavigation.back": "volver al paso anterior",
	"neptune.Info.ariaLabel": "Más información",
	"neptune.Label.optional": "(Opcional)",
	"neptune.Link.opensInNewTab": "(se abre en una pestaña nueva)",
	"neptune.MoneyInput.Select.placeholder": "Selecciona una opción...",
	"neptune.MoneyInput.Select.selectCurrencyLabel": "Selecciona una divisa",
	"neptune.PhoneNumberInput.SelectInput.placeholder": "Selecciona una opción...",
	"neptune.Select.searchPlaceholder": "Buscar...",
	"neptune.SelectInput.noResultsFound": "No se han encontrado resultados",
	"neptune.SelectOption.action.label": "Elegir",
	"neptune.SelectOption.selected.action.label": "Cambiar opción elegida",
	"neptune.StatusIcon.iconLabel.error": "Error:",
	"neptune.StatusIcon.iconLabel.information": "Información:",
	"neptune.StatusIcon.iconLabel.pending": "Pendiente:",
	"neptune.StatusIcon.iconLabel.success": "Éxito:",
	"neptune.StatusIcon.iconLabel.warning": "Advertencia:",
	"neptune.Summary.statusDone": "Apartado listo",
	"neptune.Summary.statusNotDone": "Apartado a completar",
	"neptune.Summary.statusPending": "Apartado pendiente",
	"neptune.Table.actionHeader": "Acción",
	"neptune.Table.emptyData": "Ningún resultado",
	"neptune.Table.loaded": "Los datos de la tabla se han cargado",
	"neptune.Table.loading": "Los datos de la tabla se están cargando",
	"neptune.Table.refreshPage": "Actualizar página",
	"neptune.Upload.csButtonText": "¿Quieres subir otro archivo?",
	"neptune.Upload.csFailureText": "La carga del archivo ha fallado. Por favor, inténtalo de nuevo",
	"neptune.Upload.csSuccessText": "¡Se ha subido el archivo!",
	"neptune.Upload.csTooLargeMessage": "Proporciona un archivo menor de {maxSize} MB",
	"neptune.Upload.csWrongTypeMessage": "Tipo de archivo no aceptado. Por favor, inténtalo de nuevo con un archivo diferente",
	"neptune.Upload.psButtonText": "Cancela",
	"neptune.Upload.psProcessingText": "Subiendo...",
	"neptune.Upload.retry": "Reintentar",
	"neptune.Upload.usButtonText": "O selecciona un archivo",
	"neptune.Upload.usDropMessage": "Arrastra un archivo para subirlo",
	"neptune.Upload.usPlaceholder": "Arrastra y suelta un archivo de menos de {maxSize} MB",
	"neptune.UploadButton.allFileTypes": "Todos los tipos de archivos",
	"neptune.UploadButton.dropFiles": "Arrastra un archivo para subirlo",
	"neptune.UploadButton.instructions": "{fileTypes}, menor que {size}MB",
	"neptune.UploadButton.maximumFiles": "Máximo {maxFiles} archivos.",
	"neptune.UploadButton.uploadFile": "Subir archivo",
	"neptune.UploadButton.uploadFiles": "Subir archivos",
	"neptune.UploadInput.deleteModalBody": "La eliminación de este archivo lo borrará de nuestro sistema.",
	"neptune.UploadInput.deleteModalCancelButtonText": "Cancelar",
	"neptune.UploadInput.deleteModalConfirmButtonText": "Eliminar",
	"neptune.UploadInput.deleteModalTitle": "¿Estás seguro que quieres eliminar este archivo?",
	"neptune.UploadInput.fileIsTooLarge": "El archivo es demasiado grande",
	"neptune.UploadInput.fileTypeNotSupported": "Tipo de archivo no compatible",
	"neptune.UploadInput.maximumFilesAlreadyUploaded": "Lo sentimos, ha habido un error porque solo podemos aceptar {maxFilesAllowed} archivos a la vez.",
	"neptune.UploadItem.deleting": "Eliminando...",
	"neptune.UploadItem.removeFile": "Eliminar el archivo {filename}",
	"neptune.UploadItem.uploaded": "Subido",
	"neptune.UploadItem.uploadedFile": "Archivo subido",
	"neptune.UploadItem.uploading": "Subiendo...",
	"neptune.UploadItem.uploadingFailed": "Fallo al subir el archivo"
};

export { es as default };
//# sourceMappingURL=es.json.mjs.map
